export const pushToUserlist = async (props: {
  email: string
  properties?: Record<string, string | number | boolean>
}) => {
  const response = await fetch('/api/subscribe', {
    method: 'POST',
    body: JSON.stringify(props),
  })

  return response.status === 202
}
